import script from "./VoucherForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./VoucherForm.vue?vue&type=script&lang=ts&setup=true"

import "./VoucherForm.vue?vue&type=style&index=0&id=58427066&lang=scss"

const __exports__ = script;

export default __exports__